import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CategoryListLayer from "../../components/Category/CategoryListLayer";


const CategoryList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Category" />

        {/* UsersListLayer */}
        <CategoryListLayer />

      </MasterLayout>

    </>
  );
};

export default CategoryList; 
